import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { List, ListItem, Switch } from '@knockrentals/knock-shared-web-v2';
import { DividedTabSection } from '../../TabSections';
import { GC_REQUIREMENT_TITLES } from './constants';
import { GUEST_CARD_REQUIREMENTS_FIELDS } from '../constants';
import { SECTIONS } from '../../constants';
import { guestCardRequirementsPropTypes } from '../../../../prop-types';

const { DESCRIPTION, TITLE } = SECTIONS.GC_REQUIREMENTS;

const LAST_FIELD_INDEX = GUEST_CARD_REQUIREMENTS_FIELDS.length - 1;

const GCInfoRequirements = ({
  gcInfoRequirements = {},
  updateGCInfoRequirements,
}) => {
  const handleSwitchToggle = ({ target: { name, checked } }) => {
    updateGCInfoRequirements({ [name]: checked });
  };

  return (
    <DividedTabSection
      description={DESCRIPTION}
      isDividerHidden={false}
      title={TITLE}
    >
      <List>
        {GUEST_CARD_REQUIREMENTS_FIELDS.map((name, index) => {
          const { PRIMARY, SECONDARY } = GC_REQUIREMENT_TITLES[name];
          return (
            <ListItem
              key={name}
              primary={PRIMARY}
              secondary={SECONDARY}
              divider={index < LAST_FIELD_INDEX}
              endSlot={
                <Switch
                  checked={gcInfoRequirements[name] ?? false}
                  name={name}
                  onChange={handleSwitchToggle}
                  aria-label={`${PRIMARY} switch`}
                />
              }
            />
          );
        })}
      </List>
    </DividedTabSection>
  );
};

GCInfoRequirements.propTypes = {
  gcInfoRequirements: guestCardRequirementsPropTypes,
  updateGCInfoRequirements: PropTypes.func,
};

export default memo(GCInfoRequirements);
